import React from "react";
import {safeHTML} from "../../utils/safeHTML";
import Icon from "../baseComponents/gui/icon/Icon";
import {useRouter} from "next/router";
import styles from "./News.module.scss"
import classNames from "classnames";
import Image from "next/image";

const NewsAuthorBlock = React.forwardRef(
  function NewsAuthorBlock(props, ref) {
    const {photo, first_name, last_name, socials, slug} = props;
    const router = useRouter();
    const name = `${first_name} ${last_name}`;

    return (
      <div className={styles.news__authorBlock}
           onClick={() => {
             router.push(`author/${slug}`)
           }}
           ref={ref}
      >
        <div className={styles.news__author}>
          <div className={styles.news__authorAvatar}>
            <Image src={photo} alt={'Автор'} fetchPriority="high"
                   loading="eager" width={48} height={48}/>
          </div>
          <div className={styles.news__authorName}>{safeHTML(name)}</div>
        </div>
        {socials && <div className={styles.news__socials}>
          {socials?.map(({name, link}, id) =>
            <a key={`soc-${id}`} className={classNames(styles.news__soc, styles[`news__soc_${name}`])} href={link} target={'_blank'}>
              <Icon name={`news/soc/${name}`}/>
            </a>)}
        </div>}
      </div>
    );
  });
export default NewsAuthorBlock;
NewsAuthorBlock.propTypes = {};

